import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { PushIdentityService } from './push-identity.service';
import { INSTALLATION_ID_HEADER } from '../config/push-constants';

@Injectable()
export class HttpHelperService {
    constructor(private http: HttpClient, private pushIdentityService: PushIdentityService) {
    }

    getHeaders(contentType: string = 'application/json'): { [header: string]: string } {
        const headers = {
            'Content-Type': contentType
        };
        const careHomeId = localStorage.getItem('carehome-id') || localStorage.getItem('selected_carehome');
        if (careHomeId) {
            headers['carehome-id'] = careHomeId;
        }

        // Identifies this browser profile to the backend. Sent on every call so the push subscription
        // endpoints - register, mute, department filter - all address the same registration rather
        // than whichever row happened to match a User-Agent that changes with each Chrome release.
        headers[INSTALLATION_ID_HEADER] = this.pushIdentityService.getOrCreateInstallationId();

        return headers;
    }

    getHttpOptions() {
        const headers = this.getHeaders();
        return {
            headers: new HttpHeaders(headers),
            observe: 'response' as 'response',
            withCredentials: true
        };
    }

	getHttpOptionsWithMultiPart() {
		const headers = {};
		const careHomeId = localStorage.getItem('carehome-id') || localStorage.getItem('selected_carehome');
		if (careHomeId) {
			headers['carehome-id'] = careHomeId;
		}
		headers[INSTALLATION_ID_HEADER] = this.pushIdentityService.getOrCreateInstallationId();
		return {
			headers: new HttpHeaders(headers),
			observe: 'response' as 'response',
			withCredentials: true
		};
	}

    public getHttpOptionsWithParams(params: HttpParams) {
        const headers = this.getHeaders();
        return {
            headers: new HttpHeaders(headers),
            observe: 'response' as 'response',
            params: params
        };
    }
}
